// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_d0e1e87","partnership":"_7ca3911","responsibleGaming":"_b7b778c","responsibleGamingLinks":"_0e9a339","regulatoryText":"_5f1bfa3"};